import React, { useCallback } from 'react'
import { useFieldArray } from 'react-hook-form'
import {
  text,
  button,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { v4 as uuidV4 } from 'uuid'
import { ruleActionsForUnpaid, ruleActionsForPaid } from './data'
import Action from '../../Action'

export default function RuleActions({
  control,
  trigger,
  setValue,
  isPaidAccount,
}) {
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'actions',
    // default keyName is 'id', which overrides and removes our ids
    // before submit, to prevent that we set it to 'key' and
    // let useFieldArray handles it by itself
    keyName: 'key',
  })

  const onAdd = useCallback(
    () => {
      const newEntity = {
        operator: null,
        param: null,
        value: '',
        key: uuidV4(),
      }
      append(newEntity)
    },
    [append]
  )

  const onRemove = useCallback(
    (action, index) => {
      remove(index)
    },
    [remove]
  )

  const onChange = useCallback(
    (newEntity, index) => {
      setValue(`actions.${index}`, newEntity, {
        shouldDirty: true,
        shouldValidate: true,
      })
      trigger(`actions.${index}`)
    },
    [setValue, trigger]
  )

  return (
    <>
      <div>
        {fields.map((item, index) => {
          // eslint-disable-next-line camelcase
          const { id, key } = item
          return (
            <Action
              // eslint-disable-next-line react/no-array-index-key
              control={control}
              name={`actions.${index}`}
              key={`action-${id}-${key}`}
              variables={
                isPaidAccount ? ruleActionsForPaid : ruleActionsForUnpaid
              }
              index={index}
              onRemoveAction={onRemove}
              onActionChange={onChange}
              onInput={onChange}
              totalActions={fields.length}
            />
          )
        })}
      </div>
      <div className="grui mt-5">
        <button
          type="button"
          css={[
            button.styles.link,
            text.styles.textXs,
            text.styles.textPrimary,
          ]}
          onClick={onAdd}
        >
          + Add action
        </button>
      </div>
    </>
  )
}
